import { render } from "./ParentDashboard.vue?vue&type=template&id=7cbe65d4&scoped=true"
import script from "./ParentDashboard.vue?vue&type=script&lang=js"
export * from "./ParentDashboard.vue?vue&type=script&lang=js"

import "./ParentDashboard.vue?vue&type=style&index=0&id=7cbe65d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbe65d4"]])

export default __exports__